window.addEventListener("load", function () {

  // Frame3 + Frame4 chung 1 iframe (cao ~1980px). Popup (.MS__outer position:fixed) mặc định bám
  // đỉnh iframe = vùng Frame3, nên popup mở từ Frame4 bị hiện lên trên (Frame3).
  // Giải pháp: trang cha (main.js) gửi vị trí iframe xuống bằng postMessage (chạy được cả khác
  // origin / file://), iframe dời .MS__outer về đúng VÙNG ĐANG HIỂN THỊ để popup luôn ở trước mắt.
  const outer = document.querySelector(".MS__outer");
  if (!outer) return;

  const popups = outer.querySelectorAll(".MS__popup");
  const anyActive = function () {
    for (let i = 0; i < popups.length; i++) {
      if (popups[i].classList.contains("active")) return true;
    }
    return false;
  };

  let vp = null; // geometry mới nhất nhận từ trang cha
  const positionOverlay = function () {
    if (!vp) return;
    // tỉ lệ giữa px hiển thị (trang cha) và px bên trong iframe — tự bù scale lồng nhau
    const scale = (vp.width / window.innerWidth) || 1;
    // phần iframe đã bị cuộn khỏi đỉnh viewport cha (quy về px trong iframe)
    const hiddenTop = vp.top < 0 ? -vp.top : 0;
    outer.style.top = (hiddenTop / scale) + "px";
    outer.style.bottom = "auto";
    outer.style.height = (vp.parentHeight / scale) + "px";
  };

  // Nhận vị trí iframe từ trang cha
  window.addEventListener("message", function (e) {
    const d = e.data;
    if (!d || d.__quaysoViewport !== true) return;
    vp = d;
    if (anyActive()) positionOverlay();
  });

  // Popup bật lên (class .active — dù mở bằng click hay JS kèm điều kiện) → định vị lại
  const obs = new MutationObserver(function () {
    if (anyActive()) positionOverlay();
  });
  popups.forEach(function (p) {
    obs.observe(p, { attributes: true, attributeFilter: ["class"] });
  });

});
